module.exports = __webpack_public_path__ + "static/img/Ray-Price.7c75950.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ray-Price.jpg
// module id = itpD
// module chunks = 0